<template>
    <div class="p-2">
        <h2>{{ $t("Server Stats") }}</h2>

        <server-stat v-if="config.stats_show_online_players_now" :text='$t("Players online")'
                     :count="stats.online_players_now" icon="fa-solid fa-user"/>

        <server-stat v-if="config.stats_show_online_players_last_24h" :text='$t("Players Online 24h")'
                     :count="stats.online_players_24h" icon="fa-solid fa-users"/>

        <server-stat v-if="config.stats_show_accounts_number" :text='$t("Accounts")'
                     :count="stats.accounts_created" icon="fa-solid fa-shield"/>

        <server-stat v-if="config.stats_show_players_number" :text='$t("Players")'
                     :count="stats.players_created" icon="fa-solid fa-swords"/>

        <server-stat v-if="config.stats_show_guilds_number" :text='$t("Guilds")'
                     :count="stats.guilds_created" icon="fa-solid fa-gopuram"/>

        <server-stat v-if="config.stats_show_offline_shop_number" :text='$t("Offline Shops")'
                     :count="stats.offline_shops_created" icon="fa-solid fa-shop"/>
    </div>
</template>

<script setup>
import {usePage} from "@inertiajs/inertia-vue3";
import {onBeforeUnmount, onMounted, reactive, computed} from "vue";
import axios from "axios";
import ServerStat from "@/Shared/ServerStat";

const config = computed(() => usePage().props.value.config)
const stats = computed(() => usePage().props.value.stats)
</script>
